import { connect } from 'react-redux';
import { get } from 'lodash';

import {
  getHotelLocation,
  getHotelStars,
  getHotelTitle,
  getHotelImage,
  getHotelRoulette,
} from 'checkout/store/selectors/hotel';
import {
  getEndDate,
  getTouristsText,
  getMeal,
  getNightsInHotel,
  getStartDate,
  getNightsCount,
} from 'checkout/store/selectors/package';

import { goToHotelSectionAction } from 'checkout/store/actions/view';

import { FORTUNA_ASSETS } from 'src/constants/fortunaAssets';
import { SidebarHotel } from './SidebarHotel';

const mapStateToProps = (state) => {
  const isRoulette = getHotelRoulette(state);
  return {
    location: getHotelLocation(state),
    name: getHotelTitle(state),
    stars: getHotelStars(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    touristsText: getTouristsText(state),
    image: isRoulette
      ? FORTUNA_ASSETS['packages/fortuna-room@2x.jpg']
      : get(getHotelImage(state), 'x55x56.url'),
    nights: getNightsInHotel(state),
    originalNights: getNightsCount(state),
    meal: getMeal(state),
  };
};

const mapDispatchToProps = {
  goToHotel: goToHotelSectionAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarHotel);
